import Vue from 'vue'
import moment from 'moment'

// 设置本地时区
// moment.locale('zh-cn')
moment.locale('en')
Vue.prototype.$moment = moment
